import React, { useState, useEffect, memo, useRef } from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import Select, { createFilter } from 'react-select';

import { AsyncDispatch } from '@redux/types';
import { selectGym } from '@redux/modules/gyms/actions';
import { getSelectedGymId } from '@redux/modules/gyms/selectors';
import { ROUTES_WITH_GYM_GROUPWORKOUT_FILTER_SUPPORT } from '@config';

import styles from './styles.module.css';

export interface GymFilterFormData {
    gym: string;
}

type SelectValue = {
    label: string;
    value: string;
};

export interface Props {
    gyms: { label: string; value: string }[];
}

const GymFilterForm: React.FC<
    Props & InjectedFormProps<GymFilterFormData, Props>
> = memo(({ gyms }) => {
    const dispatch = useDispatch<AsyncDispatch>();
    const selectedGymId = useSelector(getSelectedGymId);
    const willMount = useRef(true);

    const groupWorkoutLocation = ROUTES_WITH_GYM_GROUPWORKOUT_FILTER_SUPPORT.includes(
        location.pathname
    );

    const gymsOptions = groupWorkoutLocation
        ? gyms
        : [{ label: 'Все фитнес-площадки', value: '' }].concat(gyms);

    const [selectedOption, setSelectedOption] = useState<SelectValue[] | null>(
        selectedGymId
            ? gymsOptions.filter(
                  (gymOption) => gymOption.value === selectedGymId
              )
            : [{ label: 'Все фитнес-площадки', value: '' }]
    );

    useEffect(() => {
        if (willMount.current && selectedGymId) {
            dispatch(selectGym(selectedGymId));
        } else {
            dispatch(selectGym(selectedOption && selectedOption[0].value));
        }
        willMount.current = false;
    }, [selectedOption]);

    return (
        <Select
            className={styles.select}
            styles={{
                input: (provided) => ({
                    ...provided,
                    minHeight: 40,
                }),
            }}
            defaultValue={selectedOption}
            onChange={(e: SelectValue | null) => e && setSelectedOption([e])}
            options={gymsOptions}
            filterOption={createFilter({
                stringify: (option) => `${option.label}`,
            })}
            placeholder="Все фитнес-площадки"
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: 'rgb(225, 129, 65)',
                },
            })}
            noOptionsMessage={() => 'Не найдено'}
        />
    );
});

export default reduxForm<GymFilterFormData, Props>({
    form: 'gymFilter',
})(GymFilterForm);
